export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/5640253749f57ce229257494a6b0bc26.svg";